/**
 * Resolve a catalogue logo to a URL that works on ANY route.
 *
 * The API returns `logo` as a bare filename ("econet.jpg"), which the browser
 * resolves RELATIVE to the current path. On "/" that happens to work — it
 * becomes "/econet.jpg" — but on "/products/telecel" it becomes
 * "/products/econet.jpg" and 404s, so every image vanished on any nested route.
 *
 * Leaves absolute URLs and already-rooted paths alone, so a future CDN or an
 * uploaded logo keeps working.
 */
export const DEFAULT_LOGO = '/Default.png';

export function assetUrl(value, fallback = DEFAULT_LOGO) {
  if (!value || typeof value !== 'string') return fallback;

  const trimmed = value.trim();
  if (!trimmed) return fallback;

  // Absolute (http://, https://, //cdn...) or data URI — leave as-is.
  if (/^(https?:)?\/\//i.test(trimmed) || trimmed.startsWith('data:')) return trimmed;

  // Already rooted.
  if (trimmed.startsWith('/')) return trimmed;

  return `/${trimmed.replace(/^\.\//, '')}`;
}
